/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import DMCA from "./DMCA";

/* Render DMCA app into the pug template */
function render(props) {
  hydrate(<DMCA {...props} />, document.getElementById("react"));
}

render(window.reactProps);
